import { render, staticRenderFns } from "./r-ad-settings-page.vue?vue&type=template&id=71aab8e7"
import script from "./r-ad-settings-page.vue?vue&type=script&lang=js"
export * from "./r-ad-settings-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71aab8e7')) {
      api.createRecord('71aab8e7', component.options)
    } else {
      api.reload('71aab8e7', component.options)
    }
    module.hot.accept("./r-ad-settings-page.vue?vue&type=template&id=71aab8e7", function () {
      api.rerender('71aab8e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/ad-settings/r-ad-settings-page.vue"
export default component.exports